import { SVGProps } from "react";

export const SHIBIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props}>
    <circle cx="128" cy="128" r="128" fill="#F00500" />
    <g transform="translate(40, 50) scale(0.27)">
      <path
        fill="#FFFFFF"
        d="M1423.2,289.1c-16.7,16.7-32,34.8-45.6,54.1l-4.3-1.4c-24.8-8.1-50.5-13.1-76.4-14.8c-7.8-0.6-36.9-0.6-46.4,0c-28.7,1.9-50.7,6.2-75.7,14.9c-1,0.4-1.9,0.7-2.8,1c-14.1-19.2-29.8-37.2-47.1-53.7c83-42.5,180.1-47.6,267-14.1c9.3,3.5,18.4,7.6,27.3,12z"
        transform="translate(-953, -232)"
      />
      <path
        fill="#FFA409"
        d="M325,211c-43.3-78.4-81.4-78.1-89.6-77.1c1.6-9,4.6-16.9,9.3-22.9c0,0,42.4,4.2,110.8,80.2c0,0-13,6.3-30.4,19.7z"
        transform="translate(-180, -80)"
      />
    </g>
    <text
      x="128"
      y="160"
      textAnchor="middle"
      fill="#FFFFFF"
      fontFamily="Arial, sans-serif"
      fontWeight="bold"
      fontSize="72"
    >
      SHIB
    </text>
  </svg>
);
